module.exports = __webpack_public_path__ + "static/media/google-sheets-dashboard.c67c3382.png";